import { getAnalysisStatusLabel } from './getAnalysisStatusLabel';
import { CandidateBatchStatus } from 'generated-graphql/types';

/**
 * Returns a human-readable label for the status filter value.
 */
export const getAnalysisFilterLabel = (value: CandidateBatchStatus): string => {
  return getAnalysisStatusLabel(value);
};
